module.exports = __webpack_public_path__ + "img/RichAds.dd24be25.png";